module.exports = __webpack_public_path__ + "img/phone-pink.e5aa3b6e.svg";